import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListaOrcamentos from './components/ListaOrcamentos/index';


function OrcamentosListaPage() {
  useBreadcrumb([
    { name: "Administração", url: "/administracao" },
    { name: "Orçamento", url: "/administracao/orcamento" },
  ]);
  return (
    <Container>
     <ListaOrcamentos/>
    </Container>
  );
}

export default OrcamentosListaPage;
